// AdminCalendarSkeleton.jsx
import React from "react";
import "./calendarSkeleton.css";

const CalendarSkeleton = () => {
	return (
		<div className="sf-card sf-calendar-skeleton">
			{/* Top bar */}
			<div className="sf-skel-topbar shimmer"></div>

			{/* Day strip */}
			<div className="sf-skel-day-strip">
				{Array.from({ length: 7 }).map((_, i) => (
					<div key={i} className="sf-skel-day-dot shimmer"></div>
				))}
			</div>

			{/* Calendar grid */}
			<div className="sf-skel-grid">
				{/* Hours column */}
				<div className="sf-skel-hours">
					{Array.from({ length: 8 }).map((_, i) => (
						<div key={i} className="sf-skel-hour shimmer"></div>
					))}
				</div>

				{/* Staff columns */}
				<div className="sf-skel-staff-columns">
					{Array.from({ length: 3 }).map((_, c) => (
						<div key={c} className="sf-skel-staff-col">
							{/* Staff header */}
							<div className="sf-skel-staff-header shimmer"></div>

							{/* Hour rows */}
							{Array.from({ length: 8 }).map((_, r) => (
								<div key={r} className="sf-skel-hour-block shimmer"></div>
							))}

							{/* Fake event cards */}
							{c === 0 && (
								<div className="sf-skel-event shimmer"></div>
							)}

							{c === 1 && (
								<>
									<div className="sf-skel-event short shimmer"></div>
									<div className="sf-skel-event shimmer"></div>
								</>
							)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default CalendarSkeleton;
